export default function () {
  return {
    loading: false,
    current: false
  }
}
